module.exports = "//public.zight.com/packs/media/images/bill-7f493d94884fc75d11c6a20b8e4a2c55.svg";